import React, { useMemo, useState } from "react";
import axios from "axios";
import { FaArrowLeft } from "react-icons/fa";
import axiosInstance from "../components/api/axiosInstance";
import "../assets/css/EditTenant.css";
import "../assets/css/Projects.css";
import { getAuthItem } from "../utils/authStorage";
import { formValueWithMobileSanitize, mobileValidationMessage } from "../utils/phone";

const CREATE_ACCOUNT_ENDPOINT =
  process.env.REACT_APP_CREATE_ACCOUNT_URL || "http://192.168.0.104:5003/create-account";

function AddAccounts({ onBack, onCreated }) {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [formData, setFormData] = useState({
    platformName: "",
    accountName: "",
    username: "",
    password: "",
    emailUsed: "",
    contactNumber: "",
    notes: "",
    url: ""
  });

  const createdBy = useMemo(() => {
    try {
      const raw = getAuthItem("user");
      if (!raw) return 1;
      const user = JSON.parse(raw);
      return Number(user.user_id ?? user.id ?? 1) || 1;
    } catch {
      return 1;
    }
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: formValueWithMobileSanitize(name, value) }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;

    if (!formData.platformName.trim() || !formData.accountName.trim() || !formData.username.trim() || !formData.password.trim()) {
      setError("Platform Name, Account Name, Username, and Password are required.");
      return;
    }
    const contactError = mobileValidationMessage(formData.contactNumber, { label: "Contact number" });
    if (contactError) {
      setError(contactError);
      return;
    }

    setError("");
    setSubmitting(true);

    const payload = {
      Platform_Name: formData.platformName.trim(),
      Account_Name: formData.accountName.trim(),
      Username: formData.username.trim(),
      Password: formData.password,
      Email_Used: formData.emailUsed.trim() || null,
      Contact_Number: formData.contactNumber.trim() || null,
      Notes: formData.notes.trim() || null,
      URL: formData.url.trim() || null,
      Created_By: createdBy,
      tenant_id: sessionStorage.getItem("accountsTenantId") || null
    };

    try {
      let response;
      try {
        response = await axios.post(CREATE_ACCOUNT_ENDPOINT, payload);
      } catch {
        response = await axiosInstance.post("/create-account", payload);
      }

      if (!response?.data) {
        throw new Error("Invalid create-account response.");
      }

      if (onCreated) onCreated(response.data);
      if (onBack) onBack();
    } catch (err) {
      const msg =
        err.response?.data?.message ||
        err.response?.data?.error ||
        err.message ||
        "Failed to create account.";
      setError(msg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="project-form-container edittenant-container">
      <div className="viewlead-header">
        <button type="button" className="viewlead-back-link" onClick={onBack}>
          <FaArrowLeft /> Back
        </button>
      </div>

      <form className="edittenant-form" onSubmit={handleSubmit}>
        <div className="form-section">
          {error ? <div className="userstories-add-error">{error}</div> : null}

          <div className="form-grid addtask-form-grid">
            <div className="form-group">
              <label>Platform Name <span className="required">*</span></label>
              <input name="platformName" value={formData.platformName} onChange={handleInputChange} required />
            </div>

            <div className="form-group">
              <label>Account Name <span className="required">*</span></label>
              <input name="accountName" value={formData.accountName} onChange={handleInputChange} required />
            </div>

            <div className="form-group">
              <label>Username <span className="required">*</span></label>
              <input name="username" value={formData.username} onChange={handleInputChange} required />
            </div>

            <div className="form-group">
              <label>Password <span className="required">*</span></label>
              <input type="password" name="password" value={formData.password} onChange={handleInputChange} required />
            </div>

            <div className="form-group">
              <label>Email Used</label>
              <input type="email" name="emailUsed" value={formData.emailUsed} onChange={handleInputChange} />
            </div>

            <div className="form-group">
              <label>Contact Number</label>
              <input name="contactNumber" value={formData.contactNumber} onChange={handleInputChange} />
            </div>

            <div className="form-group addtask-description-full">
              <label>URL</label>
              <input type="url" name="url" value={formData.url} onChange={handleInputChange} />
            </div>

            <div className="form-group addtask-description-full">
              <label>Notes</label>
              <textarea name="notes" value={formData.notes} onChange={handleInputChange} rows={4} />
            </div>
          </div>
        </div>

        <div className="edittenant-actions">
          <button type="submit" className="btn-subproject-primary" disabled={submitting}>
            {submitting ? "Creating..." : "Create Account"}
          </button>
        </div>
      </form>
    </div>
  );
}

export default AddAccounts;
